<template>
  <div id='app'>
    <div v-show="loading">
      <p>Now loading...
      <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
      </p>
    </div>
    <div v-show="!loading" >
    <v-toolbar flat color="white">
      <v-toolbar-title data-app>送信履歴 </v-toolbar-title>
      
      <v-divider
        class="mx-5"
        inset
        vertical
      ></v-divider>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="750px" >
        <v-card>
          <v-card-title>
            <span class="headline">{{content.mailTitle}}</span>
          </v-card-title>
          <v-card-text style="white-space:pre-wrap; word-wrap:break-word;">
           {{content.mailBody}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
            <v-dialog v-model="dialog2" max-width="750px" >
        <v-card >
          <v-card-title>
            <span class="headline">送信先</span>
          </v-card-title>
          <v-card-text style="white-space:nomal; word-wrap:break-word;">
      <v-data-table
      :headers="headers2"
      :items="address"
      rows-per-page-text=""
      class="elevation-1"
      >
      <template v-slot:items="props">
        <td>{{ props.item.companyName }}</td>
        <td class="text-xs-left">{{ props.item.staffName }}</td>
        <td class="text-xs-left">{{ props.item.mail }}</td>
      </template>
    </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="list"
      :pagination.sync="pagination"
      rows-per-page-text=""
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>{{ props.item.seq }}</td>
        <td class="text-xs-left">{{ props.item.userName }}</td>
        <td class="text-xs-left">{{ props.item.mailTitle }}</td>
        <td class="text-xs-left">{{ props.item.timestamp }}</td>
        <td class="text-xs-left">
          <v-icon
            medium
            class="mr-2"
            @click="detail(props.item)"
          >
            info
          </v-icon>
        </td>
        <td class="text-xs-left">
          <v-icon
            medium
            class="mr-2"
            @click="destination(props.item)"
          >
            info
          </v-icon>
        </td>
        <!--
        <td class="text-xs-left">
          <v-icon
            medium
            class="mr-2"
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>-->
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

  export default {
    data: () => ({
      loading:true,
      dialog: false,
      dialog2:false,
      pagination: {
                sortBy: 'seq',
                descending: true,
            },
      headers: [
        {
          text: 'シーケンス番号',
          align: 'left',
          sortable: true,
          value: 'seq'
        },
        { text: '送信ユーザー名', value: 'userName' ,sortable: false},
        { text: 'メールの件名', value: 'mailTitle',sortable: false },
        { text: '送信日時', value: 'timestamp' ,sortable: false },
        { text: 'メールの内容', value: 'name', sortable: false },
        { text: '送信先', value: 'name', sortable: false },
        //{ text: '削除', value: 'name', sortable: false },
      ],
      headers2: [
        {text: '企業名',align: 'left',sortable: false,value: 'companyName'},
        {text: '担当者名',align: 'left',sortable: false,value: 'staffName'},
        {text: 'メールアドレス',align: 'left',sortable: false,value: 'mail'},
      ],
      list: [],
      content:{
        mailTitle:'',
        mailBody:''
      },
      timestamp:[],
      utc:'',
      address:[],
      editedIndex: -1,
      mailcontent: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0
      }
    }),
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    created () {
      const self = this
        axios
          .get(
            'https://a6ecsge4pk.execute-api.ap-northeast-1.amazonaws.com/RECRUITMENT_SEND/service/history/list',
            {
              headers:{
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization':sessionStorage.getItem('Authorization')
              }
            }
          )
          .then(response => {
            self.list = response.data
            //self.timestamp = self.list[self.list.indexOf(1)].timestamp
            for(var i=0;i<self.list.length;i++){
              let utc_time = Date.parse(self.list[i].timestamp)
              let jst_time = new Date()
              jst_time.setTime(utc_time+1000*60*60*9)

              let format = 'YYYY/MM/DD hh:mm:ss' 
              format = format.replace(/YYYY/g, jst_time.getFullYear())
              format = format.replace(/MM/g, ('0' + (jst_time.getMonth() + 1)).slice(-2))
              format = format.replace(/DD/g, ('0' + jst_time.getDate()).slice(-2))
              format = format.replace(/hh/g, ('0' + jst_time.getHours()).slice(-2))
              format = format.replace(/mm/g, ('0' + jst_time.getMinutes()).slice(-2))
              format = format.replace(/ss/g, ('0' + jst_time.getSeconds()).slice(-2))

          
              self.timestamp.push(format)
            }
            for(let i=0;i<self.timestamp.length;i++){
              self.list[i].timestamp=self.timestamp[i]
            }
            self.loading = false
            console.log(self.timestamp)
            console.log(response.data)
            
          })
          .catch(function(error) {
            console.log(error)
          })
    },
    methods: {
      initialize () {
        //this.list = []
      },
      detail (item){
        const self = this
        console.log(self.list[self.list.indexOf(item)].seq)
        axios
          .get(
            'https://a6ecsge4pk.execute-api.ap-northeast-1.amazonaws.com/RECRUITMENT_SEND/service/history/content',
            {
              params:{
                seq:self.list[self.list.indexOf(item)].seq
              },
              headers:{
                'Authorization':sessionStorage.getItem('Authorization')
              }
            },
             )
          .then(response => {
            self.content = response.data[0]
            console.log(response.data[0].mailTitle)
            console.log(self.content)
            this.dialog = true
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      destination (item){
        this.dialog2 = true
        const self = this
                axios
          .get(
            'https://a6ecsge4pk.execute-api.ap-northeast-1.amazonaws.com/RECRUITMENT_SEND/service/history/address',
            {
              params:{
                seq:self.list[self.list.indexOf(item)].seq
              },
              headers:{
                'Authorization':sessionStorage.getItem('Authorization')
              }
            },
             )
          .then(response => {
            self.address = response.data
            console.log(response.data)
            this.dialog2 = true
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      /*deleteItem (item) {
        const index = this.list.indexOf(item)
        confirm('このデータを削除してもよろしいですか？') && this.list.splice(index, 1)
      },*/
      close () {
        this.dialog = false
        this.dialog2 = false
        setTimeout(() => {
          this.mailcontent = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.list[this.editedIndex], this.mailcontent)
        } else {
          this.list.push(this.mailcontent)
        }
        this.close()
      }
    }
  }
</script>
<style scoped>
p {
  text-align: center;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/History.vue